import styled from 'styled-components';

import IconArrowDown from 'components/icons/arrow-down';
import { filterProps } from 'utils/filter-props';

export const Arrow = styled(filterProps(IconArrowDown, 'isOpen'))<{
  isOpen: boolean;
  fill?: string;
}>`
  height: 0.75rem;
  width: 0.75rem;

  transform: ${p => (p.isOpen ? 'rotate(180deg)' : 'none')};
  transition: transform 0.3s ease-out;

  path {
    fill: ${({ fill }) => (fill ? fill : Styles.color.black)};
  }
`;
